import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/royalties')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/royalty' })
  },
})
